import { render, staticRenderFns } from "./RandomChoice.vue?vue&type=template&id=1e8b8508&scoped=true&"
import script from "./RandomChoice.vue?vue&type=script&lang=js&"
export * from "./RandomChoice.vue?vue&type=script&lang=js&"
import style0 from "./RandomChoice.vue?vue&type=style&index=0&id=1e8b8508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b8508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VFooter,VProgressCircular,VRow})
